export function getTrustedParentOrigin() {
    return window.location.origin;
}
export function isTrustedSameOriginMessage(event) {
    return event.origin === window.location.origin;
}
